import React from "react";

import events from "resources/events.json";
import EventItem from "components/EventItem";

export default function EventsPage() {
  return (
    <section className="section">
      <h3 className="title is-3">活動回顧</h3>
      {events.map((item, i) => (
        <EventItem {...item} key={i} />
      ))}
    </section>
  );
}
